module.exports = __webpack_public_path__ + "fonts/Mukta-400-latin-ext8.23aa2c2.woff2";